module.exports = __webpack_public_path__ + "static/media/arrow-up-new.cb47c0f0.svg";